<template>
  <Modal
    :open="props.open"
    @close-modal="$emit('close-modal')"
    :custom-height="'h-auto lg:h-[300px]'"
    :custom-width="'lg:!w-[550px]'"
  >
    <template #modal-header>
      <div class="flex flex-col">
        <div class="flex gap-2 items-center">
          <Icon name="AlertTriangle" class="h-4 w-4 text-error" />
          <p class="font-inter text-sm text-error font-semibold">Cancel change investment</p>
        </div>
        <h3 class="font-semibold text-[20px] lg:text-[28px] text-strongest">
          Are you sure you want to cancel?
        </h3>
      </div>
    </template>
    <template #modal-body>
      <div class="p-6 text-strongest">
        <p class="font-inter text-strong font-medium">
          This will permanently delete all progress for this change investment, including any signed
          documents. This action cannot be undone.
        </p>
      </div>
    </template>
    <template #modal-footer>
      <div class="w-full flex justify-end gap-2">
        <Button @click="$emit('close-modal')" variant="paper-primary" size="md">
          <template #label>Go back</template>
        </Button>
        <Button @click="$emit('confirm-cancel')" variant="error" size="md">
          <template #label>Cancel change</template>
        </Button>
      </div>
    </template>
  </Modal>
</template>

<script setup>
import { Modal, Icon, Button } from "@/components";

const props = defineProps({
  open: { type: Boolean, required: true },
});

defineEmits(["close-modal", "confirm-cancel"]);
</script>
